// FLOW-01 D17 — a conexão ActionCable do painel (`actionCable.js`, a do `RoomChannel`) à disposição de
// outro canal, para ele assinar pela MESMA conexão em vez de abrir outro WebSocket. Mora à parte do
// `actionCable.js` para quem assina não carregar o store e os alertas de áudio que ele importa.
let conexao = null;

export function registrarConexao(conector, pubsubToken) {
  conexao = { conector, pubsubToken };
}

// Assina `params.channel` com a autenticação do `RoomChannel` (`pubsub_token` e `user_id`, que a
// conexão não identifica sozinha). `callbacks` são os do ActionCable (`received`, `connected`,
// `rejected`). Sem conexão aberta (antes do login, na story), devolve nulo: quem chamou relê pelo HTTP.
export function assinarCanal(params, callbacks) {
  if (!conexao) return null;
  const { conector, pubsubToken } = conexao;
  return conector.consumer.subscriptions.create(
    {
      ...params,
      pubsub_token: pubsubToken,
      user_id: conector.app.$store.getters.getCurrentUserID,
    },
    callbacks
  );
}
